import { render, staticRenderFns } from "./GpsTanks.vue?vue&type=template&id=f56a6e3e&"
import script from "./GpsTanks.vue?vue&type=script&lang=js&"
export * from "./GpsTanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports